import React from 'react';
import styled from 'styled-components';
import { Col as AntCol } from 'antd';

const Col = styled(({minZero, css, ...props}) => <AntCol {...props} />)`
    ${props => props.minZero && 'min-width: 0;'}
    ${props => props.css}
`;

export default Col;